// Sticky home-page nav with backdrop blur. CTAs route to /login or
// /post-login based on auth state — /post-login then decides between
// /welcome (first-timers) and /dashboard so signed-in users don't bounce
// through the login form.
//
// Uses plain <a> + appHref() so the same component works inside the SPA and
// inside the standalone landing build (where these targets live on a different
// origin).

import { useCurrentUser } from "@/lib/auth";
import { Logo } from "@/components/ui";
import { appHref } from "@/components/home/links";

const LINKS = [
  { label: "Templates", href: "/templates" },
  { label: "Docs", href: "#concept" },
];

export default function HomeNav() {
  const { data: user } = useCurrentUser();
  const studioHref = user ? "/post-login" : "/login";

  return (
    <nav className="sticky top-0 z-10 flex h-14 items-center gap-[18px] border-b border-border bg-canvas/80 px-7 backdrop-blur-[14px] backdrop-saturate-[160%]">
      <a href={appHref("/")} className="flex items-center gap-[9px]">
        <Logo size={22} />
        <span className="text-[13.5px] font-semibold tracking-tight text-ink">
          Harness Builder
        </span>
      </a>
      <div className="flex-1" />
      <div className="flex items-center gap-[22px]">
        {LINKS.map((l) => (
          <a
            key={l.label}
            href={appHref(l.href)}
            className="text-[12.5px] font-medium tracking-tight text-ink-2 hover:text-ink"
          >
            {l.label}
          </a>
        ))}
      </div>
      {!user && (
        <a
          href={appHref("/login")}
          className="text-[12.5px] font-medium text-ink-2 hover:text-ink"
        >
          Sign in
        </a>
      )}
      <a
        href={appHref(studioHref)}
        className="inline-flex h-8 items-center gap-1.5 rounded-lg px-[14px] text-[12.5px] font-medium text-white"
        style={{ background: "var(--accent)" }}
      >
        Open Studio
        <span className="opacity-70">↗</span>
      </a>
    </nav>
  );
}
